import React, { useState, useEffect } from 'react';
import { TextField, Button, Box } from '@mui/material';

const MwcForm = ({ initialData, onSave, onCancel }) => {
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');

  useEffect(() => {
    if (initialData) {
      setName(initialData.name);
      setAddress(initialData.address || '');
    } else {
      setName('');
      setAddress('');
    }
  }, [initialData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name) return;
    onSave({ name, address });
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
      <TextField
        label="Nama MWC"
        fullWidth
        margin="normal"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
        autoFocus
      />
      <TextField
        label="Alamat (Opsional)"
        fullWidth
        margin="normal"
        value={address}
        onChange={(e) => setAddress(e.target.value)}
        multiline
        rows={2}
      />
      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2, flexWrap: 'wrap' }}>
        <Button type="button" variant="outlined" onClick={onCancel}>
          Batal
        </Button>
        <Button type="submit" variant="contained" color="primary">
          {initialData ? 'Update' : 'Simpan'}
        </Button>
      </Box>
    </Box>
  );
};

export default MwcForm;
